import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type JobOrderIdByPublicOfferIdQueryVariables = Types.Exact<{
  offerId: Types.Scalars['String']['input'];
}>;

export type JobOrderIdByPublicOfferIdQuery = {
  __typename?: 'Query';
  publicOffer: {
    __typename?: 'PublicOfferHubType';
    jobOrder: { __typename?: 'JobOrderHubType'; jobOrderId: string; isChubVisible: boolean };
  };
};

export const JobOrderIdByPublicOfferIdDocument = gql`
  query jobOrderIdByPublicOfferId($offerId: String!) {
    publicOffer(offerId: $offerId, shouldCreateEvent: false) {
      jobOrder {
        jobOrderId
        isChubVisible
      }
    }
  }
`;

/**
 * __useJobOrderIdByPublicOfferIdQuery__
 *
 * To run a query within a React component, call `useJobOrderIdByPublicOfferIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobOrderIdByPublicOfferIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobOrderIdByPublicOfferIdQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useJobOrderIdByPublicOfferIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    JobOrderIdByPublicOfferIdQuery,
    JobOrderIdByPublicOfferIdQueryVariables
  > &
    ({ variables: JobOrderIdByPublicOfferIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<JobOrderIdByPublicOfferIdQuery, JobOrderIdByPublicOfferIdQueryVariables>(
    JobOrderIdByPublicOfferIdDocument,
    options,
  );
}
export function useJobOrderIdByPublicOfferIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JobOrderIdByPublicOfferIdQuery,
    JobOrderIdByPublicOfferIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    JobOrderIdByPublicOfferIdQuery,
    JobOrderIdByPublicOfferIdQueryVariables
  >(JobOrderIdByPublicOfferIdDocument, options);
}
export function useJobOrderIdByPublicOfferIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JobOrderIdByPublicOfferIdQuery,
        JobOrderIdByPublicOfferIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    JobOrderIdByPublicOfferIdQuery,
    JobOrderIdByPublicOfferIdQueryVariables
  >(JobOrderIdByPublicOfferIdDocument, options);
}
export type JobOrderIdByPublicOfferIdQueryHookResult = ReturnType<
  typeof useJobOrderIdByPublicOfferIdQuery
>;
export type JobOrderIdByPublicOfferIdLazyQueryHookResult = ReturnType<
  typeof useJobOrderIdByPublicOfferIdLazyQuery
>;
export type JobOrderIdByPublicOfferIdSuspenseQueryHookResult = ReturnType<
  typeof useJobOrderIdByPublicOfferIdSuspenseQuery
>;
export type JobOrderIdByPublicOfferIdQueryResult = Apollo.QueryResult<
  JobOrderIdByPublicOfferIdQuery,
  JobOrderIdByPublicOfferIdQueryVariables
>;
export function refetchJobOrderIdByPublicOfferIdQuery(
  variables: JobOrderIdByPublicOfferIdQueryVariables,
) {
  return { query: JobOrderIdByPublicOfferIdDocument, variables };
}
